export default "__VITE_ASSET__e1f374c0__"